import { render, staticRenderFns } from "./WinYourWishlistWidget.vue?vue&type=template&id=1b98623b"
import script from "./WinYourWishlistWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./WinYourWishlistWidget.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WinYourWishlistWidget.vue?vue&type=style&index=0&id=1b98623b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports